import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, TextField, Typography } from "@mui/material";
import { route } from "preact-router";
import LoadingButtonWithTooltip from "../Common/LoadingButtonWithTooltip";

export default function AmbassadorStartNewDealDialog(props) {
	const [form, setForm] = useState({ descr: "" });
	const [disabled, setDisabled] = useState(false);
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		setDisabled(form.descr.length > 0);
	}, [form]);
	const handleSubmitNewDeal = () => {
		console.log("handleSubmitNewDeal");
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				descr: form.descr,
			}),
		};
		fetch("/api/c8c4e495aa8b4a2caf7bd3b4866f43b4", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						props.onClose()
						route("/newdeala/" + res.id + "/0");
						//window.location.replace("/newdealv/" + res.id+"/0");
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Nouveau dossier de vente ambassadeur
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Typography variant="h5" gutterBottom>
					Vous souhaitez démarrer un dossier de vente.
				</Typography>
				<Typography variant="body1" gutterBottom>
					Nous allons créer un dossier et vous poser quelques questions pour le compléter. Il n'est pas obligatoire de détenir toutes les
					informations sur les vendeurs et les biens.
				</Typography>
				<Typography variant="body1" gutterBottom>
					Sous quelle appellation souhaitez-vous conserver ce dossier de vente ?
				</Typography>
				{/* <Typography variant="body2" gutterBottom>
					Cette appellation est privée, elle ne figurera pas dans les informations publiques du dossier.
				</Typography> */}
				<div>
					<TextField
						id="descr"
						name="descr"
						variant="outlined"
						style={{
							marginLeft: 0,
							marginRight: 10,
						}}
						placeholder="Nom du dossier de vente"
						fullWidth
						margin="dense"
						size="small"
						value={form.descr}
						onChange={handleChange}
					/>
				</div>

				<Typography variant="caption" gutterBottom>
					Ex: Dossier de vente maison M Martin, ...
				</Typography>
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="flex-end" alignItems="center">
					<Box>

						<LoadingButtonWithTooltip
							label={"Continuer"}
							disabled={!disabled}
							style="margin: 10px;"
							click={() => handleSubmitNewDeal()} />
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
